import { render, staticRenderFns } from "./CompanyTitle.vue?vue&type=template&id=a00678a2&scoped=true&"
import script from "./CompanyTitle.vue?vue&type=script&lang=js&"
export * from "./CompanyTitle.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTitle.vue?vue&type=style&index=0&id=a00678a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00678a2",
  null
  
)

export default component.exports